import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../Images/vc-logo.svg';
import './MainMenu.css';

const MainMenu = ( props ) => (
  <nav className="docs-main-menu">
    <img className="docs-main-menu__logo" src={logo} alt="Virtual College Logo" />
    <NavLink exact to='/' className="docs-main-menu__link" activeClassName="docs-main-menu__link--active">Home</NavLink>
    {props.pages.map((page, i) =>
      <NavLink key={i} to={`/${page.path}`} className="docs-main-menu__link" activeClassName="docs-main-menu__link--active">{page.title}</NavLink>
    )}
  </nav>
);

export default MainMenu;



// WEBPACK FOOTER //
// ./src/Components/MainMenu.js